module.exports = __webpack_public_path__ + "media/packs/obrigado-d72e8d19e90da11523d5473f4483aee3.svg";